// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1HkTq","search":"Settings_search__3ywwa","filter":"Settings_filter__1wxO4"};